import { SimulateMultiResult } from './../simulate-multi/models/simulate-multi-result.model';
import { EsoService, MassSimulationDto, DateStandard } from './../eso.service';
import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import { SimulateMultiTrainingResult } from '../simulate-multi/models/simulate-multi-training-result.model';
import { StatusMessageResultDto } from '../../general/project.service';

enum ActualSource {
	Raw = 1,
	Clean = 2,
	Clean2 = 4
}

enum ForecastSource {
	Raw = 1,
	Clean = 2
}

@Component({
    selector: 'app-simulate-multi-popup',
    templateUrl: './simulate-multi-popup.component.html',
    styleUrls: ['./simulate-multi-popup.component.scss'],
    standalone: false
})
export class SimulateMultiPopupComponent implements OnInit {
	@Input() show: boolean;
	@Input() selectedProducts: string[];

	@Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	settings: MassSimulationDto = new MassSimulationDto();

	showInfoPopup = false;
	infoPopupMessage = '';

	actualSourceOptions: string[] = [];
	forecastSourceOptions: string[] = [];
	leadTimeOptions: string[] = [];
	actualSource = '';
	forecastSource = '';
	leadTime = '';
	simulationName = 'DEFAULT NAME';

	firstWeek: Date | number | string;
	lastWeek: Date | number | string;
	firstWeekForecast: Date | number | string;
	lastWeekForecast: Date | number | string;

	public static firstWeekValidationValue: number;
	public static lastWeekValidationValue: number;
	public static firstWeekForecastValidationValue: number;
	public static lastWeekForecastValidationValue: number;

	public static firstWeekValid: boolean;
	public static lastWeekValid: boolean;
	public static firstWeekForecastValid: boolean;
	public static lastWeekForecastValid: boolean;

	public periodsValid: boolean;

	@ViewChild("SelFirstWeekStr", { static: false }) dxFirstWeekStr: DxSelectBoxComponent;
	@ViewChild("SellastWeekStr", { static: false }) dxlastWeekStr: DxSelectBoxComponent;
	@ViewChild("SelFirstWeekForecastStr", { static: false }) dxSelFirstWeekForecastStr: DxSelectBoxComponent;
	@ViewChild("SelLastWeekForecastStr", { static: false }) dxLastWeekForecastStr: DxSelectBoxComponent;
	public setPeriodsValidity() {
		this.periodsValid = SimulateMultiPopupComponent.firstWeekValid &&
			SimulateMultiPopupComponent.lastWeekValid &&
			SimulateMultiPopupComponent.firstWeekForecastValid &&
			SimulateMultiPopupComponent.lastWeekForecastValid;
	}

	public firstWeekStr: DateStandard;
	public lastWeekStr: DateStandard;
	public firstWeekForecastStr: DateStandard;
	public lastWeekForecastStr: DateStandard;
	public periodType: string;
	public yearWeeks: DateStandard[];

	private readonly captions: Map<string, string> = new Map<string, string>([
		["ActualSource-Raw", "Actual"],
		["ActualSource-Clean", "ActualClean"],
		["ActualSource-Clean2", "ActualClean"],
		["ForecastSource-Raw", "Forecast"],
		["ForecastSource-Clean", "ForecastClean"],
		["ForecastSource-Clean2", "ForecastClean"],
	]);

	constructor(private esoService: EsoService) { }

	ngOnInit() {
		this.esoService.getSimulationPeriodType().subscribe(result => {
			this.periodType = result[0];

			this.esoService.getYearWeeks().subscribe(result => {
				this.yearWeeks = result;

				this.esoService.getSimulateMultiPopupValues().subscribe(
					(simulateMultiPopUpValues) => {
						if (this.periodType !== 'Week') {
							let year = simulateMultiPopUpValues.find(x => x.name === 'First Period').value.substr(0, 4);
							let day = simulateMultiPopUpValues.find(x => x.name === 'First Period').value.slice(-2);
							var date = this.GetDateFromWeekNumber(parseInt(day), parseInt(year));
							this.firstWeek = date;

							SimulateMultiPopupComponent.firstWeekValidationValue = +(year + day);

							year = simulateMultiPopUpValues.find(x => x.name === 'Last Period').value.substr(0, 4);
							day = simulateMultiPopUpValues.find(x => x.name === 'Last Period').value.slice(-2);
							var date = this.GetDateFromWeekNumber(parseInt(day), parseInt(year));
							this.lastWeek = date;

							SimulateMultiPopupComponent.lastWeekValidationValue = +(year + day);

							year = simulateMultiPopUpValues.find(x => x.name === 'First Period Forecast').value.substr(0, 4);
							day = simulateMultiPopUpValues.find(x => x.name === 'First Period Forecast').value.slice(-2);
							var date = this.GetDateFromWeekNumber(parseInt(day), parseInt(year));
							this.firstWeekForecast = date;

							SimulateMultiPopupComponent.firstWeekForecastValidationValue = +(year + day);

							year = simulateMultiPopUpValues.find(x => x.name === 'LastWeekIdForecast').value.substr(0, 4);
							day = simulateMultiPopUpValues.find(x => x.name === 'LastWeekIdForecast').value.slice(-2);
							var date = this.GetDateFromWeekNumber(parseInt(day), parseInt(year));
							this.lastWeekForecast = date;

							SimulateMultiPopupComponent.lastWeekForecastValidationValue = +(year + day);
						}
						else {
							this.firstWeekStr = this.yearWeeks.find(x => x.yearWeek === simulateMultiPopUpValues.find(x => x.name === 'First Period').value);
							SimulateMultiPopupComponent.firstWeekValidationValue = +(this.firstWeekStr.yearWeek);

							this.lastWeekStr = this.yearWeeks.find(x => x.yearWeek === simulateMultiPopUpValues.find(x => x.name === 'Last Period').value);
							SimulateMultiPopupComponent.lastWeekValidationValue = +(this.lastWeekStr.yearWeek);

							this.firstWeekForecastStr = this.yearWeeks.find(x => x.yearWeek === simulateMultiPopUpValues.find(x => x.name === 'First Period Forecast').value);
							SimulateMultiPopupComponent.firstWeekForecastValidationValue = +(this.firstWeekForecastStr.yearWeek);

							this.lastWeekForecastStr = this.yearWeeks.find(x => x.yearWeek === simulateMultiPopUpValues.find(x => x.name === 'LastWeekIdForecast').value);
							SimulateMultiPopupComponent.lastWeekForecastValidationValue = +(this.lastWeekForecastStr.yearWeek);
						}

						this.actualSource = this.captions.get("ActualSource-" + simulateMultiPopUpValues.find((x) => x.name === "ActualSource").value);
						this.forecastSource = this.captions.get("ForecastSource-" + simulateMultiPopUpValues.find((x) => x.name === "ForecastSource").value);
						this.leadTime = simulateMultiPopUpValues.find((x) => x.name === "LeadTime").value;

						this.initializePeriodsValidity();
					}
				);
			});
		});

		this.esoService.getActualSalesOptions().subscribe(result => {
			result.forEach(element => {
				this.actualSourceOptions.push(this.captions.get("ActualSource-" + element.listElement));
			});
		});
		this.esoService.getForecastSourceOptions().subscribe(result => {
			result.forEach(element => {
				this.forecastSourceOptions.push(this.captions.get("ForecastSource-" + element.listElement));

			});
		});
		this.esoService.getLeadTimeOptions().subscribe(result => {
			result.forEach(element => {
				this.leadTimeOptions.push(element.listElement);
			});
		});
	}

	public initializePeriodsValidity() {
		SimulateMultiPopupComponent.firstWeekValid = SimulateMultiPopupComponent.firstWeekValidationValue < SimulateMultiPopupComponent.lastWeekValidationValue;
		SimulateMultiPopupComponent.lastWeekValid = SimulateMultiPopupComponent.lastWeekValidationValue > SimulateMultiPopupComponent.firstWeekValidationValue;
		SimulateMultiPopupComponent.firstWeekForecastValid = SimulateMultiPopupComponent.firstWeekForecastValidationValue < SimulateMultiPopupComponent.lastWeekForecastValidationValue;
		SimulateMultiPopupComponent.lastWeekForecastValid = SimulateMultiPopupComponent.lastWeekForecastValidationValue > SimulateMultiPopupComponent.firstWeekForecastValidationValue;

		this.setPeriodsValidity();
	}

	CallbackvalitionForecastStr() {

		if (this.dxSelFirstWeekForecastStr.value != null && this.dxSelFirstWeekForecastStr.value.yearWeek != null) {
			SimulateMultiPopupComponent.firstWeekForecastValid = +this.dxSelFirstWeekForecastStr.value.yearWeek < SimulateMultiPopupComponent.lastWeekForecastValidationValue;
			if (SimulateMultiPopupComponent.firstWeekForecastValid) {
				this.dxSelFirstWeekForecastStr.validationStatus = "valid";
			} else {
				this.dxSelFirstWeekForecastStr.validationStatus = "invalid";
			}
		}

		if (this.dxLastWeekForecastStr.value != null && this.dxLastWeekForecastStr.value.yearWeek != null) {
			SimulateMultiPopupComponent.lastWeekForecastValid = +this.dxLastWeekForecastStr.value.yearWeek > SimulateMultiPopupComponent.firstWeekForecastValidationValue;
			if (SimulateMultiPopupComponent.lastWeekForecastValid) {
				this.dxLastWeekForecastStr.validationStatus = "valid";
			} else {
				this.dxLastWeekForecastStr.validationStatus = "invalid";
			}
		}

		if (this.dxFirstWeekStr.value != null && this.dxFirstWeekStr.value.yearWeek != null) {
			SimulateMultiPopupComponent.firstWeekValid = +this.dxFirstWeekStr.value.yearWeek < SimulateMultiPopupComponent.lastWeekValidationValue;
			if (SimulateMultiPopupComponent.firstWeekValid) {
				this.dxFirstWeekStr.validationStatus = "valid";
			} else {
				this.dxFirstWeekStr.validationStatus = "invalid";
			}
		}
		if (this.dxlastWeekStr.value != null && this.dxlastWeekStr.value.yearWeek != null) {
			SimulateMultiPopupComponent.lastWeekValid = +this.dxlastWeekStr.value.yearWeek > SimulateMultiPopupComponent.firstWeekValidationValue;
			if (SimulateMultiPopupComponent.lastWeekValid) {
				this.dxlastWeekStr.validationStatus = "valid";
			} else {
				this.dxlastWeekStr.validationStatus = "invalid";
			}
		}

	}

	public onForecastErrorStartPeriodChange(e) {
		if (this.periodType === 'Week') {
			this.firstWeekForecastStr = e.value;
		} else {
			this.firstWeekForecast = e.value;
		}

		SimulateMultiPopupComponent.firstWeekValidationValue = +(this.firstWeekStr.yearWeek);
		this.CallbackvalitionForecastStr();
		this.setPeriodsValidity();
	}

	public onForecastErrorEndPeriodChange(e) {
		if (this.periodType === 'Week') {
			this.lastWeekForecastStr = e.value;
		} else {
			this.lastWeekForecast = e.value;
		}

		SimulateMultiPopupComponent.lastWeekValidationValue = +(this.lastWeekStr.yearWeek);
		this.CallbackvalitionForecastStr();
		this.setPeriodsValidity();
	}

	public onFutureForecastStartPeriodChange(e) {
		SimulateMultiPopupComponent.firstWeekForecastValidationValue = +(this.firstWeekForecastStr.yearWeek);
		this.CallbackvalitionForecastStr();
		this.setPeriodsValidity();
	}

	public onFutureForecastEndPeriodChange(e) {
		SimulateMultiPopupComponent.lastWeekForecastValidationValue = +(this.lastWeekForecastStr.yearWeek);
		this.CallbackvalitionForecastStr();
		this.setPeriodsValidity();
	}

	public validateForecastErrorStartPeriod(e): boolean {
		SimulateMultiPopupComponent.firstWeekValid = +e.value.yearWeek < SimulateMultiPopupComponent.lastWeekValidationValue;
		return SimulateMultiPopupComponent.firstWeekValid;
	}

	public validateForecastErrorEndPeriod(e): boolean {
		SimulateMultiPopupComponent.lastWeekValid = +e.value.yearWeek > SimulateMultiPopupComponent.firstWeekValidationValue;
		return SimulateMultiPopupComponent.lastWeekValid;
	}

	public validateFutureForecastStartPeriod(e): boolean {
		SimulateMultiPopupComponent.firstWeekForecastValid = +e.value.yearWeek < SimulateMultiPopupComponent.lastWeekForecastValidationValue;
		return SimulateMultiPopupComponent.firstWeekForecastValid;
	}

	public validateFutureForecastEndPeriod(e): boolean {
		SimulateMultiPopupComponent.lastWeekForecastValid = +e.value.yearWeek > SimulateMultiPopupComponent.firstWeekForecastValidationValue;
		return SimulateMultiPopupComponent.lastWeekForecastValid;
	}

	savePeriodValues() {
		this.esoService.savePeriodDefaults(
			this.firstWeekStr.yearWeek,
			this.firstWeekForecastStr.yearWeek,
			this.lastWeekStr.yearWeek,
			this.lastWeekForecastStr.yearWeek,
			this.actualSource,
			this.forecastSource,
			this.leadTime
		).subscribe(result => {

			this.showInfoPopup = true;

			this.infoPopupMessage = result.message;
		});
	}

	saveAndValidate() {


		this.esoService.savePeriodDefaultsAndValidate(
			this.firstWeekStr.yearWeek,
			this.firstWeekForecastStr.yearWeek,
			this.lastWeekStr.yearWeek,
			this.lastWeekForecastStr.yearWeek,
			this.actualSource,
			this.forecastSource,
			this.leadTime,
			true,
			this.selectedProducts
		).subscribe(result => {


			this.showInfoPopup = true;

			this.infoPopupMessage = result.message;
		});
	}

	changePopupStatus() {
		this.showChange.emit(this.show);
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = !this.showInfoPopup;
	}

	@Output() public onSimulationInitiated: EventEmitter<StatusMessageResultDto> = new EventEmitter<StatusMessageResultDto>();
	@Output() public onSimulationTrainingInitiated: EventEmitter<StatusMessageResultDto> = new EventEmitter<StatusMessageResultDto>();

	public runSimulation(): void {

		this.settings.codes = this.selectedProducts;

		if (this.periodType === 'Day') {
			if (this.firstWeek) {
				this.settings.firstWeekId = (<Date>this.firstWeek).getFullYear().toString() + this.GetWeek(this.firstWeek);
			}
			if (this.lastWeek) {
				this.settings.lastWeekId = (<Date>this.lastWeek).getFullYear().toString() + this.GetWeek(this.lastWeek);
			}
			if (this.firstWeekForecast) {
				this.settings.firstWeekIdForecast = (<Date>this.firstWeekForecast).getFullYear().toString() + this.GetWeek(this.firstWeekForecast);
			}
			if (this.lastWeekForecast) {
				this.settings.lastWeekIdForecast = (<Date>this.lastWeekForecast).getFullYear().toString() + this.GetWeek(this.lastWeekForecast);
			}
		} else {
			this.settings.firstWeekId = this.firstWeekStr.yearWeek;
			this.settings.lastWeekId = this.lastWeekStr.yearWeek;
			this.settings.firstWeekIdForecast = this.firstWeekForecastStr.yearWeek;
			this.settings.lastWeekIdForecast = this.lastWeekForecastStr.yearWeek;
		}

		this.settings.actualSource = ActualSource[this.actualSource];
		this.settings.forecastSource = ForecastSource[this.forecastSource];

		this.settings.simulationName = this.simulationName;

		this.esoService.runMultipleProductSimulation(this.settings).subscribe(
			(response: StatusMessageResultDto) => {
				this.onSimulationInitiated.emit(response);

				this.showInfoPopup = true;
				this.infoPopupMessage = response.message;

				this.show = false;
			}
		);
	}

	public initializeOptimalNumberOfThreadsForMultipleProductSimulations(): void {
		confirm('Are you sure?', 'Start Training').then(
			(value: boolean) => {
				if (value) {

					this.settings.codes = this.selectedProducts;

					if (this.periodType === 'Day') {
						if (this.firstWeek) {
							this.settings.firstWeekId = (<Date>this.firstWeek).getFullYear().toString() + this.GetWeek(this.firstWeek);
						}
						if (this.lastWeek) {
							this.settings.lastWeekId = (<Date>this.lastWeek).getFullYear().toString() + this.GetWeek(this.lastWeek);
						}
						if (this.firstWeekForecast) {
							this.settings.firstWeekIdForecast = (<Date>this.firstWeekForecast).getFullYear().toString() + this.GetWeek(this.firstWeekForecast);
						}
						if (this.lastWeekForecast) {
							this.settings.lastWeekIdForecast = (<Date>this.lastWeekForecast).getFullYear().toString() + this.GetWeek(this.lastWeekForecast);
						}
					} else {
						this.settings.firstWeekId = this.firstWeekStr.yearWeek;
						this.settings.lastWeekId = this.lastWeekStr.yearWeek;
						this.settings.firstWeekIdForecast = this.firstWeekForecastStr.yearWeek;
						this.settings.lastWeekIdForecast = this.lastWeekForecastStr.yearWeek;
					}

					this.settings.actualSource = ActualSource[this.actualSource];
					this.settings.forecastSource = ForecastSource[this.forecastSource];

					this.settings.simulationName = this.simulationName;

					this.esoService.initializeOptimalNumberOfThreadsForMultipleProductSimulations(this.settings).subscribe(
						(response: StatusMessageResultDto) => {
							this.onSimulationTrainingInitiated.emit(response);

							this.showInfoPopup = true;
							this.infoPopupMessage = response.message;

							this.show = false;
						}
					);
				}
			}
		);
	}

	private GetWeek(date: Date | number | string) {
		const dateValue: Date = new Date(date);

		const janFirst = new Date(dateValue.getFullYear(), 0, 1);
		return Math.ceil((((+(date) - +(janFirst)) / 86400000) + janFirst.getDay() + 1) / 7);
	}

	private GetDateFromWeekNumber(w, y) {
		const exactDate = new Date(y, 0, 1 + (w - 1) * 7);
		const dow = exactDate.getDay();
		const isoWeekStart = exactDate;

		if (dow <= 4) {
			isoWeekStart.setDate(exactDate.getDate() - exactDate.getDay() + 1);
		} else {
			isoWeekStart.setDate(exactDate.getDate() + 8 - exactDate.getDay());
		}

		return isoWeekStart;
	}
}
